const store = {
    namespaced: true,
    state() {
        return {
            products: [],
            page: 1,
            totalPagesCount: 1,
            totalCount: 0,
            categoryDescription: {},
            categoryBanner: null
        };
    },
    getters: {
        getProducts(state) {
            return state.products;
        },
        getPage(state) {
            return state.page;
        },
        getTotalPagesCount(state) {
            return state.totalPagesCount;
        },
        getTotalCount(state) {
            return state.totalCount;
        },
        getCategoryDescription(state) {
            return state.categoryDescription;
        },
        getCategoryBanner(state) {
            return state.categoryBanner;
        }
    },
    mutations: {
        setProducts(state, products) {
            state.products = products;
        },
        addProducts(state, products) {
            state.products = state.products.concat(products);
        },
        setPage(state, page) {
            state.page = page;
        },
        setTotalPagesCount(state, pages) {
            state.totalPagesCount = pages;
        },
        setTotalCount(state, totalCount) {
            state.totalCount = totalCount;
        },
        setCategoryDescription(state, categoryDescription) {
            state.categoryDescription = categoryDescription;
        },
        SET_CATEGORY_BANNER(state, categoryBanner) {
            state.categoryBanner = categoryBanner;
        }
    },
    actions: {
        changePage({ commit }, { query, page }) {
            if (!page) {
                page = 1;
            }
            commit('setPage', page);

            if (process.server) {
                return;
            }

            if (page !== 1) {
                this.$router.push({ query: { ...query, page: page } });

                return;
            }
            const newQuery = { ...query };
            delete newQuery.page;

            this.$router.push({ query: newQuery });
        }
    }
};

export default store;
